import { ConversationChannelTypeExtended } from '@provision/chat-utils';

export const getConversationIcon = (channel: ConversationChannelTypeExtended): string => {
  switch (channel) {
    case ConversationChannelTypeExtended.Email:
      return 'mail';
    case ConversationChannelTypeExtended.Chat:
      return 'chat_bubble';
    case ConversationChannelTypeExtended.InternalNote:
      return 'sticky_note_2';
    default:
      return 'chat_bubble';
  }
};

// max height of conversation message until message becomes collapsed in rem
export const MAX_CONVERSATION_MESSAGE_HEIGHT_REM = 16;
